module.exports = __webpack_public_path__ + "img/Return.1ecac813.svg";